angular.module("appVersion", [])
.constant("version", "4.57.2026020-6.2");
